/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */
import { createUiPushClient } from './uiPushClient';

export const uiPushClient = createUiPushClient();

if (typeof window !== 'undefined') {
  window.cdsUiPushClient = uiPushClient;
}
